import React from 'react'
import { useState, useEffect } from 'react';
import apiCaller from './ApiCaller.jsx';
import { useSelector } from 'react-redux';


export const ApiCallerConnection = ({ method, url,  data = null, headers = {}, children ,useAuth = true }) => {

  const centauri = useSelector((state) => state.auth.centauri);
  const [dataResponse, setData] = useState(null); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    
    const fetchData = async () => {
      try {

        const requestHeaders = { ...headers };
                
        if (useAuth && centauri) {
          requestHeaders.Authorization = `Bearer ${centauri}`;
        }

        setLoading(true); 
        const response = await apiCaller(method, url, data, {
          ...requestHeaders,
          /*Authorization: centauri ? `Bearer ${centauri}` : '' ,*/
          signal: abortController.signal          
        });      
        setData(response.data);
      } catch (err) {
        if (!abortController.signal.aborted) {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => abortController.abort();
  }, [centauri, method, url, JSON.stringify(data), JSON.stringify(headers),data]);

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return children({ dataResponse, loading, error });
};